import React from "react";
import { InfoCircleOutlined, ArrowRightOutlined, WarningOutlined } from "@ant-design/icons";
import styles from "./SwmsWizard.module.css";

const CATEGORIES = [
  {
    id: "rope-access",
    title: "Rope Access",
    description: "Work performed using rope access techniques at height"
  },
  {
    id: "ewp",
    title: "EWP",
    description: "Elevated Work Platform operations"
  },
  {
    id: "scaffolding",
    title: "Scaffolding",
    description: "Work from scaffolding structures"
  },
  {
    id: "ladder",
    title: "Ladder Work",
    description: "Work performed using ladders and step platforms"
  },
  {
    id: "ground",
    title: "Ground Level",
    description: "Ground level cleaning and maintenance tasks"
  },
  {
    id: "confined",
    title: "Confined Space",
    description: "Entry and work in confined spaces"
  }
];

export default function SwmsWizardStep1({
  selectedCategories,
  showValidation,
  onToggleCategory,
  onContinue
}) {
  return (
    <div className={styles.stepBody}>
      <h1 className={styles.stepTitle}>Step 1: Select Access Categories</h1>
      <p className={styles.stepSubtitle}>Choose one or more access categories for your SWMS.</p>

      <div className={styles.infoBanner}>
        <InfoCircleOutlined className={styles.infoBannerIcon} />
        Select all categories that apply. You can combine multiple work methods in a single document.
      </div>

      <div className={styles.categoryGrid}>
        {CATEGORIES.map((cat) => {
          const isSelected = selectedCategories.includes(cat.id);
          const cardClass = isSelected
            ? `${styles.categoryCard} ${styles.selected}`
            : styles.categoryCard;

          return (
            <div
              key={cat.id}
              className={cardClass}
              onClick={() => onToggleCategory(cat.id)}
            >
              <div className={styles.categoryCardContent}>
                <div className={styles.categoryCardHeader}>
                  <p className={styles.categoryCardTitle}>{cat.title}</p>
                  <input
                    type="checkbox"
                    className={styles.categoryCheckbox}
                    checked={isSelected}
                    onChange={() => onToggleCategory(cat.id)}
                    onClick={(e) => e.stopPropagation()}
                  />
                </div>
                <p className={styles.categoryCardDescription}>{cat.description}</p>
              </div>
            </div>
          );
        })}
      </div>

      {showValidation && (
        <div className={styles.validationMsg}>
          <WarningOutlined />
          Please select at least one access category to continue.
        </div>
      )}

      <div className={styles.stepFooter}>
        <button className={styles.continueButton} onClick={onContinue}>
          Continue to Methods
          <ArrowRightOutlined />
        </button>
      </div>
    </div>
  );
}
